import { Button, Col, Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import "./AssessmentTableStyles.scss";
import { CompetenciesIcon } from "assets/icons/DetailedProfile";
import NoData from "components/UI/NoData/NoData";

const colors = {
  experiences: "#990000CC",
  traits: "#2E4A79E5",
};

interface ExperienceItem {
  title: string;
  description: string;
}

interface PropsType {
  open: boolean;
  setOpen: any;
  view: string;
  setView: any;
  assessment: any;
}

const GetRow = ({
  rowData,
  index,
  view,
  TableData,
  setTableData,
}: {
  rowData: ExperienceItem;
  index: number;
  view: string;
  TableData: ExperienceItem[];
  setTableData: any;
}) => {
  const { title, description } = rowData;

  return (
    <div
      // className="assessment-row"
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        gap: "13px",
        marginBottom: "12px",
      }}
    >
      <div
        className="assessment-title-box"
        style={{
          backgroundColor: colors[view],
          color: "white",
          width: "192px",
          height: "75px",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          fontSize: "14px",
          lineHeight: "15px",
          padding: "7px",
        }}
      >
        {title}
      </div>
      <div
        className="assessment-description-box"
        style={{
          backgroundColor: colors[view],
          color: "white",
          width: "630px",
          height: "75px",
          borderRadius: "8px",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          fontSize: "14px",
          lineHeight: "15px",
          padding: "7px",
          textAlign: "left",
        }}
      >
        {description}
      </div>
    </div>
  );
};

const AssessmentTableModal: React.FC<PropsType> = ({
  open,
  setOpen,
  view,
  setView,
  assessment,
}) => {
  const [TableData, setTableData] = useState([]);

  useEffect(() => {
    if (open && view === "experiences") {
      setTableData(assessment?.experience);
    } else {
      setTableData(assessment?.traits);
    }
  }, [view, assessment]);

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal
        width={866}
        title={
          <span style={{ fontSize: 18 }}>
            <img
              src={CompetenciesIcon}
              alt="Competencies icon"
              style={{ marginRight: "10px" }}
            />
            {`Assessment table`}
          </span>
        }
        centered
        open={open}
        onCancel={handleCancel}
        footer={null}
      >
        <Row className="view-switches">
          <Button
            className={view === "experiences" && "Experience"}
            onClick={() => setView("experiences")}
          >
            Experiences
          </Button>
          <Button
            className={view === "traits" && "traits"}
            onClick={() => setView("traits")}
          >
            Traits
          </Button>
        </Row>
        {/* <div
          className="assessment-table-headings"
          style={{
            display: "flex",
            gap: "24px",
            marginBottom: "12px",
            marginLeft: "2px",
          }}
        >
          <div
            style={{
              width: "192px",
              fontWeight: 600,
              fontSize: "14px",
              color: "black",
            }}
          >
             
          </div>
          <div
            style={{
              width: "630px",
              fontWeight: 600,
              fontSize: "14px",
              color: "black",
            }}
          >
            Definitions
          </div>
        </div> */}
        <div style={{ width: "100%" }}>
          {TableData?.length > 0 && TableData[0]?.title ? (
            TableData?.map((row, index) => {
              return (
                <GetRow
                  key={index}
                  rowData={row}
                  index={index}
                  view={view}
                  TableData={TableData}
                  setTableData={setTableData}
                />
              );
            })
          ) : (
            <NoData message={`No required ${view} added`} />
          )}
        </div>
      </Modal>
    </>
  );
};

export default AssessmentTableModal;
